import { getCityIdFromCityName } from 'reducers/IncReducer';
import store from '../../config/configureStore';

export const createCit = async (data) => {
  const client = store.store.getState().websocket.websocket;
  const user = store.store.getState().user.userData?.user.Username;

  if (!client) return;
  try {
    const service = client.service('cit-citations');
    service.timeout = 20000000;
    const result = await service.create({
      ...data,
      IsLocked: false,
      IsSealed: false,
      IsDeleted: false,
      CreatedBy: user,
      UpdatedBy: user,
    });

    return result;
  } catch (e) {
    console.log(e);
  }
};

export const patchCit = async (id, data) => {
  const client = store.store.getState().websocket.websocket;
  const user = store.store.getState().user.userData?.user.Username;

  if (!client) return;
  try {
    const service = client.service('cit-citations');
    service.timeout = 20000000;
    const result = await service.patch(id, {
      ...data,
      IsLocked: false,
      IsSealed: false,
      IsDeleted: false,
      CreatedBy: user,
      UpdatedBy: user,
    });

    return result;
  } catch (e) {
    console.log(e);
  }
};

export const createCitEntity = async (data, entity) => {
  const client = store.store.getState().websocket.websocket;
  const user = store.store.getState().user.userData?.user.Username;

  if (!client) return;
  try {
    const service = client.service(entity);
    service.timeout = 20000;
    const result = await service.create({
      ...data,
      IsLocked: false,
      IsSealed: false,
      IsDeleted: false,
      CreatedBy: user,
      UpdatedBy: user,
    });

    return result;
  } catch (e) {
    console.log(e);
  }
};

export const patchCitEntity = async (id, data, entity) => {
  const client = store.store.getState().websocket.websocket;
  const user = store.store.getState().user.userData?.user.Username;

  if (!client) return;
  try {
    const service = client.service(entity);
    service.timeout = 20000;
    const result = await service.patch(id, {
      ...data,
      IsLocked: false,
      IsSealed: false,
      IsDeleted: false,
      UpdatedBy: user,
    });

    return result;
  } catch (e) {
    console.log(e);
  }
};

export const upsertCitPerson = async (ptsCitationId) => {
  const incidentState = store.store.getState().incident;
  const client = store.store.getState().websocket.websocket;
  const user = store.store.getState().user.userData?.user.Username;
  const service = client.service('citation-party');
  service.timeout = 100000;

  const {
    partiesPersonForm,
    partiesContactForm,
    partiesEmploymentForm,
    partiesOthersForm,
  } = incidentState;

  if (Object.keys(partiesPersonForm.values).length === 0) return;

  if (typeof partiesContactForm.values?.city === 'string') {
    partiesContactForm.values.cityId = getCityIdFromCityName(partiesContactForm.values?.city);
  }

  if (typeof partiesEmploymentForm.values?.city === 'string') {
    partiesEmploymentForm.values.cityId = getCityIdFromCityName(partiesEmploymentForm.values?.city);
  }

  const requestBody = {
    ptsCitationId,
    tempPartyId: partiesPersonForm.tempPartyId,
    ptsPersonId: partiesPersonForm.ptsPersonId,
    ptsIncPersonId: partiesPersonForm.ptsCitationPersonId,
    partyType: partiesPersonForm.values.partyType,
    personDetail: partiesPersonForm,
    contactDetail: partiesContactForm,
    employmentDetail: partiesEmploymentForm,
    otherDetail: partiesOthersForm,
    user: user,
  };

  let response;
  if (partiesPersonForm.ptsCitationPersonId) {
    response = await service.patch(null, requestBody);
  } else {
    response = await service.create(requestBody);
  }

  return response;
};

export const getOfficerBadgeId = async (ptsPersonID) => {
  const client = store.store.getState().websocket.websocket;
  if (!client) return;

  try {
    const service = client.service('ptspersoncredentials');
    service.timeout = 100000;
    const result = await service.find({
      query: { ptsPersonID: ptsPersonID, Type: 'Badge', IsDeleted: 0, $select: ['Number'] },
    });

    if (!result || !result.data || !result.data.length) return null;
    return result.data[0]?.Number || null;
  } catch (e) {
    console.log(e);
  }
};
export const upsertCitLocation = async (ptsCitationId) => {
  const incidentState = store.store.getState().incident;
  let { addressForm, addressIdForm, coordinatesForm } = incidentState;
  const user = store.store.getState().user.userData?.user.Username;
  const client = store.store.getState().websocket.websocket;

  if (!addressForm) return;

  if (!client) {
    return;
  }

  if (typeof addressForm.values?.city === 'string') {
    addressForm.values.cityId = getCityIdFromCityName(addressForm.values?.city);
  }

  if (Object.keys(addressForm.values).length <= 1) return;

  const addressRequestBody = {
    ptsCitationId: ptsCitationId,
    ptsAddressId: addressForm?.ptsAddressId,
    addressDetails: addressForm,
    addressIdDetails: addressIdForm,
    addressCoordinatesDetails: coordinatesForm,
    user: user,
  };

  const service = client.service('citation-address');

  let response;
  if (addressForm?.values?.ptsCitationLocationID) {
    response = await service.patch(addressForm?.ptsAddressId, addressRequestBody);
  } else {
    response = await service.create(addressRequestBody);
  }

  return response;
};

//TODO: Will refactor
export const upsertCitVehicle = async (ptsCitationId) => {
  const incidentState = store.store.getState().incident;
  const client = store.store.getState().websocket.websocket;
  const user = store.store.getState().user.userData?.user.Username;

  const { propertyVehicleDetailsForm, propertyCredentialsAnalysisForm } = incidentState;
  const { attachments } = propertyVehicleDetailsForm.values;

  try {
    let vehicleRegistrationData = {};
    let vehicleDetailsData = {};
    let newEntityitem, data;

    let defPlace = null;
    if (
      !propertyVehicleDetailsForm.values?.propertyOwner ||
      !propertyVehicleDetailsForm.values?.propertyOwnerType
    ) {
      const defPlaceRes = await getVehicleDetaultPlace();
      defPlace = defPlaceRes && defPlaceRes.ValueNumeric ? defPlaceRes.ValueNumeric : 1;
    }

    vehicleDetailsData = {
      VIN: propertyCredentialsAnalysisForm?.values?.vin || '',
      Make: propertyVehicleDetailsForm?.values?.make || '',
      Model: propertyVehicleDetailsForm?.values?.model || '',
      Style: propertyVehicleDetailsForm?.values?.style || '',
      Year: propertyVehicleDetailsForm?.values?.year || '',
      PrimaryColor: propertyVehicleDetailsForm?.values?.primaryColor || '',
      IsTowed: propertyVehicleDetailsForm?.values?.isTowed || false,
      Brand: propertyVehicleDetailsForm?.values?.brand || '',
      Brander: propertyVehicleDetailsForm?.values?.brander || '',
      CommercialID: propertyCredentialsAnalysisForm?.values?.commercialId || '',
      Commercial: propertyCredentialsAnalysisForm?.values?.commercialCode || '',
      IsCMVIndicator: propertyCredentialsAnalysisForm?.values?.cmv || '',
      PropertyID: propertyCredentialsAnalysisForm?.values?.propertyId || '',
      Property: propertyCredentialsAnalysisForm?.values?.propertyCode || '',
      EmissionInspectionQty: propertyCredentialsAnalysisForm?.values?.emissionInspection || '',
      GarageFacility: propertyCredentialsAnalysisForm?.values?.garageFacility || '',
      GarageIndicator: propertyCredentialsAnalysisForm?.values?.garageIndicator || '',
      VINAnalysisText: propertyCredentialsAnalysisForm?.values?.vinAnalysisTest || '',
      IsRented: propertyCredentialsAnalysisForm?.values?.rented || false,
      Classification: propertyVehicleDetailsForm?.values?.classification || '',
      SecondaryColor: propertyCredentialsAnalysisForm?.values?.secondaryColor || '',
      InteriorColor: propertyCredentialsAnalysisForm?.values?.interior || '',
      PassengerSafeQty: propertyCredentialsAnalysisForm?.values?.passengerQuantity || '',
      SeatQty: propertyCredentialsAnalysisForm?.values?.seatQuantity || '',
      Transmission: propertyCredentialsAnalysisForm?.values?.transmissionCode || '',
      IsWanted: propertyCredentialsAnalysisForm?.values?.wanted || false,
      Description: propertyVehicleDetailsForm?.values?.description || '',
      PropertyOwner: propertyVehicleDetailsForm.values.propertyOwner || defPlace || '',
      PropertyOwnerType: propertyVehicleDetailsForm.values.propertyOwnerType || 'PLACE',
    };
    vehicleRegistrationData = {
      ptsParentID: propertyVehicleDetailsForm.values.propertyOwner || defPlace,
      PartyType: propertyVehicleDetailsForm.values.propertyOwnerType || 'PLACE',
      PlateType: propertyCredentialsAnalysisForm?.values.plateType || '',
      PlateColor: propertyCredentialsAnalysisForm?.values.plateColor || '',
      PlateNumber: propertyCredentialsAnalysisForm?.values.plateNumber || '',
      PlateState: propertyCredentialsAnalysisForm?.values.plateState || '',

      PlateExpiration: propertyCredentialsAnalysisForm?.values.plateExpiration
        ? new Date(propertyCredentialsAnalysisForm?.values.plateExpiration).toLocaleDateString()
        : '',
      PlateStatus: propertyCredentialsAnalysisForm?.values.plateStatus || '',
      PlateDetail: propertyCredentialsAnalysisForm?.values.plateDetail || '',
      PlateBackgroundText: propertyCredentialsAnalysisForm?.values.plateBackgroundText || '',
      UpdatedBy: user,
      Value: propertyVehicleDetailsForm?.values?.value || '',
    };

    //start Handling Parent Vehicle details

    if (!propertyVehicleDetailsForm.ptsVehicleID && !propertyVehicleDetailsForm.ptsVehicleId) {
      newEntityitem = await createCitEntity(
        { ...vehicleDetailsData, UpdatedBy: user },
        'ptsvehicle'
      );
      vehicleRegistrationData = {
        ...vehicleRegistrationData,
        ptsVehicleID: newEntityitem.ptsVehicleID,
        UpdatedBy: user,
        CreatedBy: user,
      };

      await createCitEntity(vehicleRegistrationData, 'ptsvehiclereg');
    } else {
      newEntityitem = {
        ...vehicleDetailsData,
        ptsVehicleID: propertyVehicleDetailsForm.ptsVehicleID || propertyVehicleDetailsForm.ptsVehicleId,
      };
    }

    //end vehicle registration

    if (propertyVehicleDetailsForm.ptsCitationVehicleID) {
      data = {
        VIN: propertyCredentialsAnalysisForm?.values?.vin || '',
        LicensePlate: propertyCredentialsAnalysisForm?.values.plateNumber || '',

        LicensePlateExpiration: propertyCredentialsAnalysisForm?.values.plateExpiration
          ? new Date(propertyCredentialsAnalysisForm?.values.plateExpiration).toLocaleDateString()
          : '',
        LicenseState: propertyCredentialsAnalysisForm?.values.plateState || '',
        Make: propertyVehicleDetailsForm?.values?.make || '',
        Model: propertyVehicleDetailsForm?.values?.model || '',
        Style: propertyVehicleDetailsForm?.values?.style || '',
        Year: propertyVehicleDetailsForm?.values?.year || '',
        Color: propertyVehicleDetailsForm?.values?.primaryColor || '',
        IsTowed: propertyVehicleDetailsForm?.values?.isTowed || false,
        TowedBy: propertyVehicleDetailsForm?.values?.towedBy || false,
        IsSeatBeltInUse: propertyVehicleDetailsForm?.values?.isSeatBeltInUse || false,
        IsHazard: propertyVehicleDetailsForm?.values?.isHazard || false,
        IsCommercial: propertyVehicleDetailsForm?.values?.isCommercial || false,
        IsAccident: propertyVehicleDetailsForm?.values?.IsAccident || false,
        Classification: propertyVehicleDetailsForm?.values?.classification || '',
        Brand: propertyVehicleDetailsForm?.values?.brand || '',
        Brander: propertyVehicleDetailsForm?.values?.brander || '',
        VINAnalysisText: propertyCredentialsAnalysisForm?.values?.vinAnalysisTest || '',
        PropertyID: propertyCredentialsAnalysisForm?.values?.propertyId || '',
        Property: propertyCredentialsAnalysisForm?.values?.propertyCode || '',
        CommercialID: propertyCredentialsAnalysisForm?.values?.commercialId || '',
        Commercial: propertyCredentialsAnalysisForm?.values?.commercialCode || '',
        IsCMVIndicator: propertyCredentialsAnalysisForm?.values?.cmv || '',
        EmissionInspectionQty: propertyCredentialsAnalysisForm?.values?.emissionInspection || '',
        Transmission: propertyCredentialsAnalysisForm?.values?.transmissionCode || '',
        PlateType: propertyCredentialsAnalysisForm?.values.plateType || '',
        PlateColor: propertyCredentialsAnalysisForm?.values.plateColor || '',
        PlateStatus: propertyCredentialsAnalysisForm?.values.plateStatus || '',
        PlateDetail: propertyCredentialsAnalysisForm?.values.plateDetail || '',
        PlateBackgroundText: propertyCredentialsAnalysisForm?.values.plateBackgroundText || '',
        IsRented: propertyCredentialsAnalysisForm?.values?.rented || false,
        IsWanted: propertyCredentialsAnalysisForm?.values?.wanted || false,
        GarageIndicator: propertyCredentialsAnalysisForm?.values?.garageIndicator || '',
        GarageFacility: propertyCredentialsAnalysisForm?.values?.garageFacility || '',
        PassengerSafeQty: propertyCredentialsAnalysisForm?.values?.passengerQuantity || '',
        SeatQty: propertyCredentialsAnalysisForm?.values?.seatQuantity || '',
        SecondaryColor: propertyCredentialsAnalysisForm?.values?.secondaryColor || '',
        InteriorColor: propertyCredentialsAnalysisForm?.values?.interior || '',
        Description: propertyVehicleDetailsForm?.values?.description || '',
        PropertyOwner: propertyVehicleDetailsForm.values.propertyOwner || defPlace || '',
        PropertyOwnerType: propertyVehicleDetailsForm.values.propertyOwnerType || 'PLACE',
        ptsCitationID: ptsCitationId,
        ptsVehicleID: newEntityitem.ptsVehicleID,
        UpdatedBy: user,
      };

      newEntityitem = await patchCitEntity(
        propertyVehicleDetailsForm.ptsCitationVehicleID,
        data,
        'citcitationvehicles'
      );

      if (attachments && attachments.length > 0) {
        const attachmentService = client.service('rms-attachments');
        attachmentService.timeout = 20000;

        for (const f of attachments) {
          if (!f.ptsAttachmentId) {
            await attachmentService.create({
              ptsParentID: propertyVehicleDetailsForm.ptsCitationVehicleID,
              parentType: 'CITATIONVEHICLE',
              file: f.file,
              description: f.description,
              fileName: f.name,
              fileType: f.fileType,
              codeAttachmentType: f.codeAttachmentType,
              data: f.data,
              IsLocked: false,
              IsSealed: false,
              IsDeleted: false,
              UpdatedBy: user,
              CreatedBy: user,
            });
          }
        }
      }

      return newEntityitem;
    } else {
      data = {
        VIN: propertyCredentialsAnalysisForm?.values?.vin || '',
        LicensePlate: propertyCredentialsAnalysisForm?.values.plateNumber || '',
        LicensePlateExpiration: propertyCredentialsAnalysisForm?.values.plateExpiration
          ? new Date(propertyCredentialsAnalysisForm?.values.plateExpiration).toLocaleDateString()
          : null,
        LicenseState: propertyCredentialsAnalysisForm?.values.plateState || '',
        Make: propertyVehicleDetailsForm?.values?.make || '',
        Model: propertyVehicleDetailsForm?.values?.model || '',
        Style: propertyVehicleDetailsForm?.values?.style || '',
        Year: propertyVehicleDetailsForm?.values?.year || '',
        Color: propertyVehicleDetailsForm?.values?.primaryColor || '',
        IsTowed: propertyVehicleDetailsForm?.values?.isTowed || false,
        TowedBy: propertyVehicleDetailsForm?.values?.towedBy || false,
        IsSeatBeltInUse: propertyVehicleDetailsForm?.values?.isSeatBeltInUse || false,
        IsHazard: propertyVehicleDetailsForm?.values?.isHazard || false,
        IsCommercial: propertyVehicleDetailsForm?.values?.isCommercial || false,
        IsAccident: propertyVehicleDetailsForm?.values?.isAccIsAccident || false,
        Classification: propertyVehicleDetailsForm?.values?.classification || '',
        Brand: propertyVehicleDetailsForm?.values?.brand || '',
        Brander: propertyVehicleDetailsForm?.values?.brander || '',
        VINAnalysisText: propertyCredentialsAnalysisForm?.values?.vinAnalysisTest || '',
        PropertyID: propertyCredentialsAnalysisForm?.values?.propertyId || '',
        Property: propertyCredentialsAnalysisForm?.values?.propertyCode || '',
        CommercialID: propertyCredentialsAnalysisForm?.values?.commercialId || '',
        Commercial: propertyCredentialsAnalysisForm?.values?.commercialCode || '',
        IsCMVIndicator: propertyCredentialsAnalysisForm?.values?.cmv || '',
        EmissionInspectionQty: propertyCredentialsAnalysisForm?.values?.emissionInspection || '',
        Transmission: propertyCredentialsAnalysisForm?.values?.transmissionCode || '',
        PlateType: propertyCredentialsAnalysisForm?.values.plateType || '',
        PlateColor: propertyCredentialsAnalysisForm?.values.plateColor || '',
        PlateStatus: propertyCredentialsAnalysisForm?.values.plateStatus || '',
        PlateDetail: propertyCredentialsAnalysisForm?.values.plateDetail || '',
        PlateBackgroundText: propertyCredentialsAnalysisForm?.values.plateBackgroundText || '',
        IsRented: propertyCredentialsAnalysisForm?.values?.rented || false,
        IsWanted: propertyCredentialsAnalysisForm?.values?.wanted || false,
        GarageIndicator: propertyCredentialsAnalysisForm?.values?.garageIndicator || '',
        GarageFacility: propertyCredentialsAnalysisForm?.values?.garageFacility || '',
        PassengerSafeQty: propertyCredentialsAnalysisForm?.values?.passengerQuantity || '',
        SeatQty: propertyCredentialsAnalysisForm?.values?.seatQuantity || '',
        SecondaryColor: propertyCredentialsAnalysisForm?.values?.secondaryColor || '',
        InteriorColor: propertyCredentialsAnalysisForm?.values?.interior || '',
        Description: propertyVehicleDetailsForm?.values?.description || '',
        ptsCitationID: ptsCitationId,
        ptsVehicleID: newEntityitem.ptsVehicleID,
        PropertyOwner: propertyVehicleDetailsForm.values.propertyOwner || defPlace || '',
        PropertyOwnerType: propertyVehicleDetailsForm.values.propertyOwnerType || 'PLACE',
        CreatedBy: user,
        UpdatedBy: user,
      };

      newEntityitem = await createCitEntity(data, 'citcitationvehicles');

      if (attachments && attachments.length > 0) {
        const attachmentService = client.service('rms-attachments');
        attachmentService.timeout = 20000;

        for (const f of attachments) {
          if (!f.ptsAttchmentId) {
            await attachmentService.create({
              ptsParentID: newEntityitem.ptsCitationVehicleID,
              parentType: 'CITATIONVEHICLE',
              file: f.file,
              description: f.description,
              fileName: f.name,
              fileType: f.fileType,
              codeAttachmentType: f.codeAttachmentType,
              data: f.data,
              IsLocked: false,
              IsSealed: false,
              IsDeleted: false,
              UpdatedBy: user,
              CreatedBy: user,
            });
          }
        }
      }

      return newEntityitem;
    }
  } catch (error) {
    console.log(error);
  }
};

export const removeCitEntity = async (entity, data) => {
  const wsClient = store.store.getState().websocket.websocket;
  const definition = {
    citcitations: {
      service: 'citcitations',
      datbaseKey: 'ptsCitationID',
    },
    citcitationlocations: {
      service: 'citcitationlocations',
      datbaseKey: 'ptsCitationLocationID',
    },
    ptstags: {
      service: 'ptstags',
      datbaseKey: 'ptsTagID',
    },
    citcitationpersons: {
      service: 'citcitationpersons',
      databaseKey: 'ptsCitationPersonID',
    },
    citcitationvehicles: {
      service: 'citcitationvehicles',
      databaseKey: 'ptsCitationVehicleID',
    },
    citcitationviolations: {
      service: 'citcitationviolations',
      databaseKey: 'ptsCitationViolationID',
    },
    ptscomments: {
      service: 'ptscomments',
      databaseKey: 'ptsCommentID',
    },
    'rms-attachments': {
      service: 'rms-attachments',
      databaseKey: 'ptsAttachmentID',
    },
  };

  try {
    const serviceName = definition[entity].service;
    const service = wsClient.service(serviceName);
    service.timeout = 20000;

    await service.remove(data);
  } catch (error) {
    console.log(error);
  }
};

export const getVehicleDetaultPlace = async () => {
  const wsClient = store.store.getState().websocket.websocket;
  const service = wsClient.service('settings-add-vehicle-default-place');
  service.timeout = 20000;
  try {
    const data = await service.find();
    return data;
  } catch (error) {
    console.log(error);
  }
};
